import { inject, Injectable, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '@core';
import { IProductTax, ITaxRequest } from '@models';

@Injectable({
  providedIn: 'root',
})
export class TaxService {
  private readonly apiService = inject(ApiService);

  readonly productTax = signal<IProductTax | null>(null);

  fetchProductTax(body: ITaxRequest): Observable<IProductTax> {
    return this.apiService.post<IProductTax>('tax', body).pipe(tap((tax) => this.productTax.set(tax)));
  }
}
